import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import MembershipForm from "./pages/Membershipform";
import DevoteeForm from "./pages/Devotee";
import Welcome from "./pages/Welcome"

function App() {
  return (
    <Router>
      <div className="col-12">

        <Routes>
           <Route path="/" element={<Welcome />} />
          <Route path="/membership" element={<MembershipForm />} />
          <Route path="/devotee" element={<DevoteeForm />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
